import { FormattedMessage } from 'react-intl';

export const WhatDoYouLikeTitle = () => (
  <span data-testid="what-do-you-like-vp-title">
    <FormattedMessage id="vp.whatDoYouLike.title" />
  </span>
);